export default __webpack_public_path__ + "static/media/tooltip.7b001be1.svg";